// The heading-anchor rule, on its own so a test can import the real thing.
//
// An image slot's position is "after-<slugified H2>", matched at render time
// by _render_body_with_slots in agents/seo_drafting.py using
//   re.sub(r"[^a-z0-9]+", "-", text.lower()).strip("-")
//
// The same rule lives in three places: there, in SQL (_s31_heading_anchors)
// and here. If they ever disagree an image silently fails to appear, which is
// how Cynthia Bullard's post ended up with five slots pointing at headings it
// no longer had — five photos could have gone in and none would have shown,
// with no error anywhere.
//
// scripts/slugcheck.mjs runs this file against the Python renderer on the same
// inputs. It imports from here rather than keeping its own copy, because a
// test that checks a copy of the rule proves nothing about the rule that ships.
// Plain JS, no React, so node can import it directly.

export const slugOfHeading = (t) =>
  t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

// Every H2 in the article, in order, as { heading, anchor }. Headings that
// slugify to nothing are dropped: the database refuses a bare "after-", so
// offering one would be offering a dead option.
export function headingsOf(md) {
  const out = [];
  for (const line of String(md || '').replace(/\r\n/g, '\n').split('\n')) {
    const m = /^##[ \t]+(.+?)[ \t]*$/.exec(line);
    if (!m) continue;
    const anchor = slugOfHeading(m[1]);
    if (anchor) out.push({ heading: m[1], anchor });
  }
  return out;
}
